export enum CountryCodeEnum {
    CH = '86', //中国
    US_CA = '1',  //美国 or 加拿大 1#10
    GB = '44', //英国 44#10
    AU = '61',  //澳大利亚 61#9
    DE = '49', //德国 49#11
    FR = '33', //法国 33#9
    JP = '81', //日本 81#10
}

const validateUS_CAPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{10}$/;
    return regExp.test(phoneNumber);
}

const validateGBPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{10}$/;
    return regExp.test(phoneNumber);
}

const validateAUPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{9}$/;
    return regExp.test(phoneNumber);
}

const validateDEPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{11}$/;
    return regExp.test(phoneNumber);
}

const validateFRPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{9}$/;
    return regExp.test(phoneNumber);
}

const validateJPPhoneNumber = (phoneNumber: string) => {
    let regExp = /^\d{10}$/;
    return regExp.test(phoneNumber);
}


const validateCHPhoneNumber = (phoneNumber: string) => {
    let regExp = /^(?:0|86|＋?86)?1[3-9]\d{9}$/;
    return regExp.test(phoneNumber);
}

export const checkPhoneNumber = (phoneNumber: string, area?: string) => {
    if (!area) return false;

    if (area === CountryCodeEnum.US_CA) {
        return validateUS_CAPhoneNumber(phoneNumber);
    }
    else if (area === CountryCodeEnum.CH) {
        return validateCHPhoneNumber(phoneNumber);
    }
    else if (area === CountryCodeEnum.GB) {
        return validateGBPhoneNumber(phoneNumber);
    } else if (area === CountryCodeEnum.AU) {
        return validateAUPhoneNumber(phoneNumber);
    } else if (area === CountryCodeEnum.DE) {
        return validateDEPhoneNumber(phoneNumber);
    } else if (area === CountryCodeEnum.FR) {
        return validateFRPhoneNumber(phoneNumber);
    } else if (area === CountryCodeEnum.JP) {
        return validateJPPhoneNumber(phoneNumber);
    }

    return false;
}

export const validatePassword = (password: string) => {
    let regExp = /^.{8,}$/;
    if (regExp){
        return regExp.test(password);
    }
    return false;
}